import { render } from "./TwitterVerified.vue?vue&type=template&id=1440d491"
import script from "./TwitterVerified.vue?vue&type=script&lang=js"
export * from "./TwitterVerified.vue?vue&type=script&lang=js"

import exportComponent from "/Users/leopons/Desktop/1_bm_dev/bubblemaps-showcase/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__